import React, { useState, useRef, useEffect,useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import swal from "sweetalert";
import { v4 as uuidv4 } from "uuid";
import {ContextApi} from "../../../App"


function Checkbox({ onMoveDown, onMoveUp, onElementDelete, preset }) {
  // States
  const [element, setElement] = useState({
    id: uuidv4(),
    type: "checkbox",
    properties: {
      label: "Checkbox question field.",
      options: [],
      columns: 1,
    },
    required: false,
    fillableByCandidate: true,
    fillableByHR: false,
    disableField: false,
  });
  const contextData = useContext(ContextApi)
  const [options, setOptions] = useState([]);
  const [modal, setModal] = useState(false);

  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementAnswerRef = useRef();
  const elementRequiredRef = useRef();
  const disableFieldRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
      if (preset.properties) setOptions(preset.properties.options);
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    setElement((previousState) => {
      previousState.properties.label = elementLabelRef.current.value;
      previousState.properties.required = elementRequiredRef.current.checked;
      previousState.properties.options = options;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      previousState.disableField = disableFieldRef.current.checked;
      return previousState;
    });
    toggle();
    contextData.setContextData({
      ...contextData.contextData,
      isEdit :!contextData.contextData.isEdit
    })
  }

  function onAddNewAnswer(event) {
    if (elementAnswerRef.current.value !== "") {
      setOptions((state) => {
        state = [...state, elementAnswerRef.current.value];
        elementAnswerRef.current.value = "";

        return state;
      });
    } else {
      swal("Input box should not be empty");
    }
  }

  function onDeleteOption(event) {
    const value = event.target.getAttribute("v");
    setOptions((state) => {
      let newState = [];
      for (let index = 0; index < state.length; index++) {
        const element = state[index];
        if (element !== value) {
          newState.push(element);
        }
      }
      return newState;
    });
  }

  function onChangeColumns(event) {
    const value = parseInt(event.target.value);
    setElement((previous) => {
      let state = { ...previous };
      state.properties.columns = value;
      return state;
    });
  }

  return (
    <div
      className="form-group mb-3 form-builder-element"
      data={JSON.stringify(element)}
    >
      <button
        className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right"
        onClick={(e) => onElementDelete(e,element)}
      >
        <i className="fa fa-trash"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={toggle}
      >
        <i className="fa fa-asterisk"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveUp}
      >
        <i className="fa fa-chevron-up"></i>
      </button>
      <button
        className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right"
        onClick={onMoveDown}
      >
        <i className="fa fa-chevron-down"></i>
      </button>

      <label htmlFor="">
        {element.properties.label}
        {element.properties.required && <span style={{color:'red'}}>*</span>}
      </label>
      <div className="row">
        {options.map((v, k) => (
          <div
            key={k}
            className={"mb-3 col-md-" + 12 / (element.properties.columns || 1)}
          >
            <div className="custom-control custom-checkbox mb-2">
              <input type="checkbox" className="custom-control-input" />
              <label className="custom-control-label">
                {k + 1}. {v}
              </label>
            </div>
          </div>
        ))}
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Checkbox Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Question</label>
            <input
              ref={elementLabelRef}
              defaultValue={element.properties.label}
              type="text"
              className="form-control"
            />
          </div>
          <div className="form-group">
            <label>Answers</label>
            {options.map((v, k) => (
              <div className="mb-3" key={k}>
                {k + 1}. {v}{" "}
                <button
                  className="btn btn-sm btn-danger float-right"
                  v={v}
                  onClick={onDeleteOption}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
          <div className="form-group">
            <div className="input-group">
              <input
                ref={elementAnswerRef}
                type="text"
                className="form-control"
              />
              <div className="input-group-append">
                <button className="btn btn-primary" onClick={onAddNewAnswer}>
                  Add
                </button>
              </div>
            </div>
          </div>
          <div className="form-group">
            <select
              name="columns"
              id="columns"
              className="form-control"
              defaultValue={element.properties.columns}
              onChange={onChangeColumns}
            >
              <option value="1">1 column (Single Lined)</option>
              <option value="2">2 columns</option>
              <option value="3">3 columns</option>
              <option value="4">4 columns</option>
            </select>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              ref={elementRequiredRef}
              className="custom-control-input"
              id="requiredCheck"
              defaultChecked={element.properties.required}
            />
            <label className="custom-control-label" htmlFor="requiredCheck">
              Mandatory?
            </label>
          </div>

          <div className="custom-control custom-checkbox formbuilder-hidden">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox formbuilder-hidden">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              ref={disableFieldRef}
              type="checkbox"
              className="custom-control-input"
              id="disableField"
              defaultChecked={element.disableField}
            />
            <label className="custom-control-label" htmlFor="disableField">
              Disable preFilled Field(only admin can edit)
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Checkbox;
